import React from 'react'
import PropTypes from 'prop-types'
import MuiDialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'

const DialogTitle = ({ onClose, children }) => {
  const { t } = useTranslation()
  return (
    <MuiDialogTitle
      sx={theme => ({
        borderBottom: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing(1),
        display: 'flex',
        alignItems: 'center',
      })}
    >
      {children}
      {onClose ? (
        <IconButton
          aria-label={t('Close')}
          sx={{ marginLeft: 'auto' }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  )
}

DialogTitle.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.node,
}
export default DialogTitle
